export const CONTENTS = [
  // {
  //   videoLink: "https://youtube.com/shorts/9kWdakEKOkg?si=DYMCPwp2g_FNwAkv",
  //   title:
  //     "Swagat Vyas shares smart tips to manage finances before buying your dream home.",
  //   desc: `Planning your dream home starts with smart financial decisions. In this guide, Mr. Swagat Vyas shares practical tips to help you manage savings, evaluate loan options, and plan your budget wisely. Build the right financial foundation today and move closer to owning the home you’ve always imagined. 💼🏡✨`,
  //   id: "9kWdakEKOkg",
  // },
  // {
  //   videoLink: "https://www.youtube.com/shorts/E-WjoGL24as",
  //   title:
  //     "Key home buying tips by Mr. Swagat Vyas – from trusted builder to quality & transparency",
  //   desc: `Buying a home is one of the biggest decisions of your life, and making the right choice matters. Mr. Swagat Vyas highlights the key factors every homebuyer should focus on—like choosing a reliable builder, checking construction quality, and ensuring complete transparency at every stage. With these trusted insights, you can secure a home that’s built on value, trust, and peace of mind. 🏠✨`,
  //   id: "E-WjoGL24as",
  // },
  {
    videoLink: "https://www.youtube.com/watch?v=766IJuSNVrU",
    title:
      "The Autograph ft. Mr. Swagat Vyas from the Vishwanath Group | A Dream Lived & Driven, Brick by Brick",
    desc: `From Spaces to Horsepower From building timeless spaces to driving raw horsepower — this is the story of a visionary who built his empire brick by brick and now drives the legacy forward.`,
    id: "766IJuSNVrU",
  },
  {
    videoLink: "https://www.youtube.com/watch?v=-96kgKmRqG4",
    title:
      "What truly matters when buying a home? Swagat Vyas joins NewSpatial to share timeless insights.",
    desc: `Swagat Vyas, MD of Vishwanath Builders, joins New Capital for an insightful conversation on what makes a home stand out — from timeless design and mindful planning to choosing the right project that adds long-term value.`,
    id: "-96kgKmRqG4",
  },
  {
    id: "8RBg_avjHI8",
    title: "Vishwanath Builders | Civil Engineering Insights",
    desc: "Civil Engineering Insights: Unveiling On-Site Experience and India's Skyscraper Scenario.......",
    videoLink: "https://www.youtube.com/watch?v=8RBg_avjHI8",
  },
  {
    videoLink: "https://www.youtube.com/watch?v=sOyOj9WACmo",
    title: "TIMES GEN NEXT AWARDS GUJRAT 2024",
    desc: "Swagat Vyas:A Promising and Innovative Developer",
    id: "sOyOj9WACmo",
  },
];
